<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'app-settings-col'
}
</script>
